import { configureStore } from '@reduxjs/toolkit';
import CustomerDetailsReducer from './customerDetailsInfo';
import AppConfigReducer from './appConfigInfo';
import DirectoryReducer from './directory';
import OfferEngineReducer from './offerEngine';
import BookingHubReducer from './bookingHub';

export default configureStore({
  reducer: {
    customerDetailsInfo: CustomerDetailsReducer,
    appConfigInfo: AppConfigReducer,
    directory: DirectoryReducer,
    offerEngine: OfferEngineReducer,
    bookingHub: BookingHubReducer,
  },
})